import Link from "next/link";
import styles from "./post-hero.module.scss";

export interface IPostHeroProps {
	title: string;
	excerpt: string;
	date: string;
	slug: string;
}

const PostHero = ({ title, date, slug, excerpt }: IPostHeroProps): JSX.Element => {
	return (
		<article className={styles.postHero}>
			<h1>{title}</h1>
			<div className={styles.content} dangerouslySetInnerHTML={{ __html: excerpt.replace(/<a\b[^>]*>(.*?)<\/a>/i, "") }} />
			<time dateTime={date}>{date}</time>

			<footer>
				<Link as={`/${slug}`} href="/[slug]">
					<a className={styles.btnMore}>saiba mais</a>
				</Link>
			</footer>
		</article>
	);
};

export default PostHero;
